const Config = {
  StackName: "prod-doc-analyzer",
  DefaultImageName: "default_document_3.png",
  CognitoIdentityPoolId: "us-east-1:8480e3e7-78d9-4c6f-90f0-9bcc4e433db8",
  CognitoUserPoolId: "us-east-1_t8pUO4nol",
  DeployRegion: "us-east-1",
  CognitoId: "cognito-idp.us-east-1.amazonaws.com/us-east-1_t8pUO4nol",
  APIUrl: "https://qe4g6o4rqh.execute-api.us-east-1.amazonaws.com/prod",
  LogoutUrl:
    "https://prod-aarp-platform.auth.us-east-1.amazoncognito.com/logout?client_id=46c306757e9a78ord7esj8f8n0&logout_uri=https://portal.aarp.us.spsglobal.com&response_type=token",
  LoginUrl:
    "https://prod-aarp-platform.auth.us-east-1.amazoncognito.com/login?client_id=46c306757e9a78ord7esj8f8n0&response_type=token&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https://portal.aarp.us.spsglobal.com",
  ChatExternalLink: "https://www.google.com",
  TicketExternalLink: null,
  AnalyticsExternalLink: "https://reports.aarp.us.spsglobal.com/",
};

export default Config;
